var productList = [
    {
        "VariantId":  "33149387440237",
        "Name":  "M14-1.25 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149403824237",
        "Name":  "PF-3/8 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149396811885",
        "Name":  "1/2-20 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149399138413",
        "Name":  "1/2 NPT ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149393829997",
        "Name":  "M16-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149381771373",
        "Name":  "M12-1.25 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149391175789",
        "Name":  "M14-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149395992685",
        "Name":  "M20-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149385736301",
        "Name":  "M12-1.75 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149397631085",
        "Name":  "M22-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149397991533",
        "Name":  "M24-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33172227096685",
        "Name":  "M14-1.50 (0.875 Thread Length Sprinter Vans) Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149402087533",
        "Name":  "3/4-16 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149395009645",
        "Name":  "M18-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "33149384720493",
        "Name":  "M12-1.50 ValvoMax Quick Twist Oil Drain Valve"
    },
    {
        "VariantId":  "41631258312813",
        "Name":  "3/8 x 18 NPT ValvoMax Quick Twist Oil Drain Valve"
    }
];
